/*
 * fw-motion.js — 見出しのピョコンの印と、キャッチの句読点の位置合わせ（2026-10-07 新設）
 * 見た目と決め＝assets/fw-motion.css の冒頭。
 *
 * ① キャッチの句読点（全員に効く・動きではない）：行の終わりに来た「、」「。」は、字の形が枠の左半分にしか無く、
 *    右半分の空白の分だけ行が左に寄って見える（晃久さん 2026-10-07「あるとセンターズレて見える」）。
 *    行の終わりに来たものだけ fw-catch__ch--end を付けて、右の空白を詰める（CSS）。行の途中の読点は詰めない。
 *    位置は transform の影響を受けない offsetTop で比べる（跳ねている途中でも正しく測る）。幅が変わったら測り直す。
 * ② 見出しのピョコン：
 *    - 「動きを減らす」の人（html に fw-motion が無い）には何もしない。
 *    - 最初から画面にある見出しには印を付けない（読み込み直後のちらつきを出さない）。
 *    - 1回出たら見張りをやめる（スクロールのたびに動かない・軽い）。
 */
(function () {
  var root = document.documentElement;

  // ① キャッチの句読点
  var PUNCT = /^[、。，．]$/;
  // 改行の位置は「詰める前」の並びで決めて、その位置に br を入れて固定する。
  // 詰めた分で次の言葉が同じ行に上がると、スマホで1行に詰まって見えた（2026-10-07 撮影で確認＝2行のほうがきれい）
  function markLineEnds() {
    var heads = document.querySelectorAll('.fw-catch');
    Array.prototype.forEach.call(heads, function (h) {
      var olds = h.querySelectorAll('.fw-catch__br');
      for (var k = 0; k < olds.length; k++) olds[k].parentNode.removeChild(olds[k]);
      var chs = h.querySelectorAll('.fw-catch__ch');
      var i, ends = [];
      for (i = 0; i < chs.length; i++) chs[i].classList.remove('fw-catch__ch--end');
      for (i = 0; i < chs.length; i++) {
        var c = chs[i];
        if (!PUNCT.test(c.textContent)) continue;
        var n = chs[i + 1];
        if (!n || n.offsetTop > c.offsetTop + 2) ends.push({ c: c, n: n });
      }
      ends.forEach(function (e) {
        e.c.classList.add('fw-catch__ch--end');
        if (e.n && e.n.parentNode && e.n.parentNode.parentNode === h) {
          var br = document.createElement('br');
          br.className = 'fw-catch__br';
          h.insertBefore(br, e.n.parentNode);
        }
      });
    });
  }
  if (document.querySelector('.fw-catch')) {
    markLineEnds();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(markLineEnds);
    var lastW = window.innerWidth;
    var timer = null;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return; // スマホのアドレスバーの出入り（高さだけの変化）では測らない
      lastW = window.innerWidth;
      clearTimeout(timer);
      timer = setTimeout(markLineEnds, 150);
    });
  }

  // ここから下は動き。「動きを減らす」の人（html に fw-motion が無い）と、IntersectionObserver が無い古い作りには何もしない
  if (!root.classList.contains('fw-motion')) return;
  if (!('IntersectionObserver' in window)) return;

  var vh = window.innerHeight || root.clientHeight;
  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < vh && r.bottom > 0;
  }
  function seen(e) {
    return e.isIntersecting || e.intersectionRatio > 0; // isIntersecting が無い古い作りでも出す
  }

  try {
    // 先に全部を測ってから、まとめて印を付ける。測る→印を付ける→測る…と交互にすると、そのたびに画面の計算をやり直して重い
    // （2026-10-11 実測：回線と CPU を絞ったスマホで、交互にしていた版は長い処理が 1〜2 個増えていた）
    var targets = document.querySelectorAll('.sectionHeading:not(.fw-page-part__catch)');
    var popList = Array.prototype.filter.call(targets, function (el) {
      return !inView(el); // 最初から見えている見出し＝動かさない
    });
    var pick = function (list, skipInView) {
      var out = [];
      for (var k = 0; k < list.length; k++) {
        var el = list[k];
        if (el.fwRiseSeen) continue;
        el.fwRiseSeen = true;
        if (!el.getClientRects().length) continue; // 見えない（display:none）ものは触らない
        if (skipInView && inView(el)) continue; // 開いた時点で見えている＝隠さない
        out.push(el);
      }
      return out;
    };
    // 商品の一覧（トップの各コレクション・コレクションのページ）。横に送る作り（slider）と余白用の隠しカードは除く
    var cardList = pick(document.querySelectorAll('ul.product-grid:not(.slider) > li.grid__item:not(.card-hidden)'), true);
    var feed = document.getElementById('insta-feed');
    var instaList = feed ? pick(feed.querySelectorAll('.instafeed-new-layout-item'), true) : [];

    // ② 見出しのピョコン
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!seen(e)) return;
          e.target.classList.add('is-shown');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
    );
    popList.forEach(function (el) {
      el.classList.add('fw-pop');
      io.observe(el);
    });

    // ④ 見出しの画像のゆらゆら（2026-10-11 晃久さん「ひらがなワッペンとか…出てきたら若干揺れてた方が可愛い」）
    //    画像の見出しだけ（字の見出し・キャッチには付けない）。揺らすのは画面に入っている間だけ（fw-sway-on・CSS の ④）。
    //    この見張りは外さない（入る・出るを毎回知る必要がある）。数は1ページに10個ほど
    var swayIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (seen(e)) e.target.classList.add('fw-sway-on');
        else e.target.classList.remove('fw-sway-on');
      });
    });
    Array.prototype.forEach.call(targets, function (el) {
      if (!el.querySelector('img')) return;
      el.classList.add('fw-sway');
      swayIO.observe(el);
    });

    // ⑤ 商品の一覧とインスタ：行ごとに下から（2026-10-11 晃久さん「行でぴょこんと下から出る」「インスタも…行でふわっと」）
    //    - 開いた時点で見えているカードには印を付けない（隠さない＝LCP を遅らせない・ちらつかせない）。
    //    - 行の誰かが画面の下 12% の線を越えたら、同じ行（同じ親の中で上端がそろうもの）を同時に出す。1回出たら見張りをやめる。
    //    - 後から差し替わったカード（絞り込みで一覧が描き直された等）は印が無い＝そのまま見える。
    var showRow = function (row) {
      row.forEach(function (c) {
        c.classList.add('is-in');
        rowIO.unobserve(c);
        fullIO.unobserve(c);
      });
    };
    var notReady = function (img) {
      return !img.complete || !img.naturalWidth || /placeholder/.test(img.currentSrc || img.src);
    };
    var reveal = function (el) {
      if (el.fwRiseBusy || el.classList.contains('is-in')) return;
      var p = el.parentNode;
      if (!p) return;
      var top = el.getBoundingClientRect().top;
      var row = [];
      for (var c = p.firstElementChild; c; c = c.nextElementSibling) {
        if (c.fwRiseBusy || !c.classList.contains('fw-rise') || c.classList.contains('is-in')) continue;
        if (Math.abs(c.getBoundingClientRect().top - top) < 4) row.push(c);
      }
      if (!row.length) return;
      row.forEach(function (c) {
        c.fwRiseBusy = true;
      });
      // インスタは写真が届くまで少し待つ（アプリが画面の 200px ほど手前で本物の写真に差し替える。
      // 待たないと、出た後に写真がパッと替わる）。待つのは最長 1.2 秒
      var waits = [];
      row.forEach(function (c) {
        if (!c.classList.contains('fw-rise--insta')) return;
        var imgs = c.querySelectorAll('img');
        for (var k = 0; k < imgs.length; k++) if (notReady(imgs[k])) waits.push(imgs[k]);
      });
      if (!waits.length) return showRow(row);
      var done = false;
      var go = function () {
        if (done) return;
        done = true;
        clearTimeout(timer);
        showRow(row);
      };
      var check = function () {
        for (var k = 0; k < waits.length; k++) if (notReady(waits[k])) return;
        go();
      };
      var timer = setTimeout(go, 1200);
      waits.forEach(function (im) {
        im.addEventListener('load', check);
        im.addEventListener('error', go);
      });
    };
    var rowIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (seen(e)) reveal(e.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0 }
    );
    // 受け皿：ページの終わりで 12% の線まで上げられない行も、全部見えたら出す
    var fullIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (seen(e) && e.intersectionRatio >= 0.97) reveal(e.target);
        });
      },
      { threshold: 0.98 }
    );
    var markList = function (list, extra) {
      list.forEach(function (el) {
        el.classList.add('fw-rise');
        if (extra) el.classList.add(extra);
        rowIO.observe(el);
        fullIO.observe(el);
      });
    };
    markList(cardList, '');

    // インスタ（アプリ Instafeed）。写真の箱は読み込みの後にアプリが差し込む（iframe ではない）。
    // 差し込まれた瞬間（まだ描かれる前）に印を付けるので、その時に画面の中にあっても隠してから出す。
    // この JS より先に差し込まれていたら、見えているものは隠さない（上の instaList）。見張りは 20 秒でやめる
    if (feed) {
      markList(instaList, 'fw-rise--insta');
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function () {
          try {
            markList(pick(feed.querySelectorAll('.instafeed-new-layout-item'), false), 'fw-rise--insta');
          } catch (err) {
            root.classList.remove('fw-motion');
          }
        });
        mo.observe(feed, { childList: true, subtree: true });
        setTimeout(function () {
          mo.disconnect();
        }, 20000);
      }
    }
  } catch (err) {
    // 途中で止まったら、隠したものを残さない（fw-motion を外す＝CSS の隠す規則が全部外れる）
    root.classList.remove('fw-motion');
  }
})();
